/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Footnote_HistoryInputs */

const en_admin_funnel_footnote_history = /** @type {(inputs: Admin_Funnel_Footnote_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffic since launch: browser page views and visits come from Cloudflare Web Analytics (a JS beacon only real browsers send, so crawlers are excluded) imported by scripts/sync-traffic.ts. It is sampled: page views are the steadier number; visits (page loads arriving from outside the site) are a rough estimate at this traffic level, so no conversion rate is computed from them. Free previews = distinct devices (the feature ran Oct 2-9). Sign-ups, started checkout (distinct users who created an order), payers and revenue come from the user and order tables. The CN/HK switch only removes those countries from page views and visits.`)
};

/**
* | output |
* | --- |
* | "Traffic since launch: browser page views and visits come from Cloudflare Web Analytics (a JS beacon only real browsers send, so crawlers are excluded) import..." |
*
* @param {Admin_Funnel_Footnote_HistoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_history = /** @type {((inputs?: Admin_Funnel_Footnote_HistoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_HistoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_history(inputs)
});
export { admin_funnel_footnote_history as "admin.funnel.footnote.history" }